import React from 'react';

export default function withPage(Component, page) {
  return class WithPage extends React.Component {
    static displayName = 'WithPage(' + Component.displayName + ')';

    /**
     * @override
     */
    componentDidMount() {
      window.scrollTo(0, 0);
    }
    /**
     * @override
     */
    render() {
      return <Component currentPage={page} {...this.props} />;
    }
  };
}



// WEBPACK FOOTER //
// ./src/hoc/withPage.js